//auth
export const SET_TOKEN = "setToken"
export const SET_FMCTOKEN = "setFMCToken"
export const SET_LOGGEDUSER = "setLoggedUser"
export const SET_CONFIGURATIONS = "setConfigurations"